const clientConfig = {
  virgin: {
    favicon: "/virgin_favicon.jpeg",
    title: "Virgin Atlantic Connections Game",
    description:
      "Find groups of four words that share a connection. Discover what connects them all!",
    themeColor: "#e10600", // Virgin Atlantic red
    fonts: {
      type: "local",
      fontFamily: "Gotham",
      files: [
        { weight: 300, style: "normal", file: "Gotham-Light.otf" },
        { weight: 400, style: "normal", file: "Gotham-Book.otf" },
        { weight: 500, style: "normal", file: "Gotham-Medium.otf" },
        { weight: 700, style: "normal", file: "Gotham-Bold.otf" },
        { weight: 900, style: "normal", file: "Gotham-Black.otf" },
        { weight: 400, style: "italic", file: "Gotham-BookIta.otf" },
        { weight: 700, style: "italic", file: "Gotham-BoldIta.otf" },
      ],
    },
  },
  delta: {
    favicon: "/delta_favicon.png",
    title: "Delta Connections Game",
    description:
      "Find groups of four words that share a connection. Discover what connects them all!",
    themeColor: "#003366", // Delta blue
    fonts: {
      type: "local",
      fontFamily: "Whitney Condensed",
      files: [
        { weight: 300, style: "normal", file: "WhitneyCondensed-Light.otf" },
        { weight: 400, style: "normal", file: "WhitneyCondensed-Book.otf" },
        { weight: 500, style: "normal", file: "WhitneyCondensed-Medium.otf" },
        { weight: 600, style: "normal", file: "WhitneyCondensed-Semibold.otf" },
        { weight: 900, style: "normal", file: "WhitneyCondensed-Black.otf" },
      ],
    },
  },
  blueprint: {
    favicon: "/blueprint_favicon.png",
    title: "Blueprint NYC Connections Game",
    description:
      "Find groups of four words that share a connection. A word association game by Blueprint NYC.",
    themeColor: "#000000", // Blueprint black
    fonts: {
      type: "local",
      fontFamily: "Montserrat",
      files: [
        { weight: 300, style: "normal", file: "Montserrat-Light.ttf" },
        { weight: 400, style: "normal", file: "Montserrat-Regular.ttf" },
        { weight: 500, style: "normal", file: "Montserrat-Medium.ttf" },
        { weight: 600, style: "normal", file: "Montserrat-SemiBold.ttf" },
        { weight: 700, style: "normal", file: "Montserrat-Bold.ttf" },
        { weight: 800, style: "normal", file: "Montserrat-ExtraBold.ttf" },
        { weight: 900, style: "normal", file: "Montserrat-Black.ttf" },
      ],
    },
  },
  sfta: {
    favicon: "/sfta_favicon.png",
    title: "SFTA Connections Game",
    description: "Find groups of four words that share a connection.",
    themeColor: "#dc4405",
    fonts: {
      type: "local",
      fontFamily: "Proxima Nova",
      files: [
        { weight: 400, style: "normal", file: "ProximaNovaAlt-Regular.otf" },
        { weight: 400, style: "italic", file: "ProximaNovaAlt-RegularIt.otf" },
        { weight: 700, style: "normal", file: "ProximaNovaAlt-Bold.otf" },
        { weight: 700, style: "italic", file: "ProximaNovaAlt-BoldIt.otf" },
        { weight: 900, style: "normal", file: "ProximaNovaAlt-Black.otf" },
        { weight: 900, style: "italic", file: "ProximaNovaAlt-BlackIt.otf" },
      ],
    },
  },
  ucb: {
    favicon: "/ucb_favicon.png",
    title: "UCB Connections Game",
    description: "Find groups of four words that share a connection.",
    themeColor: "#C79F49",
    fonts: {
      type: "local",
      fontFamily: "MuseoSans",
      files: [
        { weight: 300, style: "normal", file: "MuseoSans-300.otf" },
        { weight: 300, style: "italic", file: "MuseoSans-300Italic.otf" },
        { weight: 500, style: "normal", file: "MuseoSans-500.otf" },
        { weight: 500, style: "italic", file: "MuseoSans-500Italic.otf" },
        { weight: 700, style: "normal", file: "MuseoSans-700.otf" },
        { weight: 700, style: "italic", file: "MuseoSans-700Italic.otf" },
        { weight: 900, style: "normal", file: "MuseoSans-900.otf" },
        { weight: 900, style: "italic", file: "MuseoSans-900Italic.otf" },
      ],
    },
  },
  airfrance: {
    favicon: "/af_favicon.png",
    title: "Air France Memory Game",
    description: "Match pairs of images by remembering where each card is.",
    themeColor: "#FF0000",
    fonts: {
      type: "local",
      fontFamily: "Excellence In Motion",
      files: [
        { weight: 300, style: "normal", file: "ExcellenceInMotion-Thin.otf" },
        {
          weight: 400,
          style: "normal",
          file: "ExcellenceInMotion-Regular.otf",
        },
        { weight: 500, style: "normal", file: "ExcellenceInMotion-Medium.otf" },
        { weight: 700, style: "normal", file: "ExcellenceInMotion-Bold.otf" },
        { weight: 900, style: "normal", file: "ExcellenceInMotion-Black.otf" },
      ],
    },
  },
  azbax: {
    favicon: "/bax_favicon.png",
    title: "BAX Connections Game",
    description: "Find groups of four words that share a connection.",
    themeColor: "#3C1053",
    fonts: {
      type: "local",
      fontFamily: "Barlow Condensed",
      files: [
        { weight: 300, style: "normal", file: "BarlowCondensed-Light.ttf" },
        { weight: 400, style: "normal", file: "BarlowCondensed-Regular.ttf" },
        { weight: 500, style: "normal", file: "BarlowCondensed-Medium.ttf" },
        { weight: 600, style: "normal", file: "BarlowCondensed-SemiBold.ttf" },
        { weight: 700, style: "normal", file: "BarlowCondensed-Bold.ttf" },
        { weight: 800, style: "normal", file: "BarlowCondensed-ExtraBold.ttf" },
      ],
    },
  },
  default: {
    favicon: "/blueprint_favicon.png",
    title: "Connections Game",
    description: "Find groups of four words that share a connection.",
    themeColor: "#000000",
    fonts: {
      type: "google",
      urls: [
        "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap",
      ],
      fontFamily: "Open Sans",
    },
  },
};

export default clientConfig;
